'use client';
import { TableHeadline, TablePrimaryHeader, TablesMultiplier } from '..';
import { ResultsTable } from '../../../ResultsTable/ResultsTable';
import { usePrizeTablesContext } from '../../context';

/**
 * PrizeTablesWithMultiplier component renders a set of prize tables with available multiplier values,
 * that will amend amount values presented to end user.
 * Multipliers only affect main table (if there were extra tables to be rendered).
 */
function PrizeTablesWithMultiplier() {
  const { tables, namespace, className, lotteryName, extraGames, drawingDate, multipliers, multiplier, setMultiplier, tooltips } = usePrizeTablesContext();

  const primaryTable = tables.find(table => table.lotteryId === lotteryName);
  if (!primaryTable) return null;
  const extraTables = tables.filter(table => table.lotteryId !== primaryTable!.lotteryId);

  return (
    <>
      <div className={className}>
        <TablePrimaryHeader namespace={namespace} />
        <TablesMultiplier multipliers={multipliers} selectedMultiplier={multiplier} setSelectedMultiplier={setMultiplier} />
        <ResultsTable data={primaryTable.data} tooltips={tooltips} />
      </div>
      {extraTables && extraTables.length > 0
        ? extraTables.map(({ lotteryId, data }) => (
            <div key={lotteryId} className={className}>
              <TableHeadline lotteryName={lotteryName} isPrimaryTable={false} extraGameId={lotteryId!} drawingDate={drawingDate} extraGames={extraGames} />
              <ResultsTable data={data} />
            </div>
          ))
        : null}
    </>
  );
}

export { PrizeTablesWithMultiplier };
